"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.agnosticSubDays = exports.agnosticAddDays = void 0;
const firstDayOfTheYear_1 = require("./firstDayOfTheYear");
const date_fns_1 = require("date-fns");
const agnosticAddDays = (date, amount) => {
    const originalTZO = date.getTimezoneOffset();
    const endDate = (0, date_fns_1.addDays)(date, amount);
    const endTZO = endDate.getTimezoneOffset();
    const dstDiff = originalTZO - endTZO;
    return dstDiff >= 0 ? (0, date_fns_1.addMinutes)(endDate, dstDiff) : (0, date_fns_1.subMinutes)(endDate, Math.abs(dstDiff));
};
exports.agnosticAddDays = agnosticAddDays;
const agnosticSubDays = (date, amount) => {
    const originalTZO = date.getTimezoneOffset();
    const endDate = (0, date_fns_1.subDays)(date, amount);
    const endTZO = endDate.getTimezoneOffset();
    const dstDiff = originalTZO - endTZO;
    return dstDiff >= 0 ? (0, date_fns_1.subMinutes)(endDate, dstDiff) : (0, date_fns_1.addMinutes)(endDate, Math.abs(dstDiff));
};
exports.agnosticSubDays = agnosticSubDays;
const days_from_monday = { Mon: 0, Tue: 1, Wed: 2, Thu: 3, Fri: 4, Sat: 5, Sun: 6 };
const get_day_days = {
    0: { dayName: "Sun", offSetFromWeekStart: 6 },
    1: { dayName: "Mon", offSetFromWeekStart: 0 },
    2: { dayName: "Tue", offSetFromWeekStart: 1 },
    3: { dayName: "Wed", offSetFromWeekStart: 2 },
    4: { dayName: "Thu", offSetFromWeekStart: 3 },
    5: { dayName: "Fri", offSetFromWeekStart: 4 },
    6: { dayName: "Sat", offSetFromWeekStart: 5 },
};
const weekNumberAndDayToDate = ({ weekNumber, dayName, year = 2024 }) => {
    const firstDay = (0, firstDayOfTheYear_1.firstDateOfTheYear)(year);
    let numberOfDaysToAddToFirstDay = 0;
    const dayOfFirstDay = (0, date_fns_1.getDay)(firstDay);
    const dayNumber = days_from_monday[dayName];
    numberOfDaysToAddToFirstDay = numberOfDaysToAddToFirstDay + dayNumber - get_day_days[dayOfFirstDay].offSetFromWeekStart;
    return (0, exports.agnosticAddDays)(firstDay, (weekNumber - 1) * 7 + numberOfDaysToAddToFirstDay);
};
exports.default = weekNumberAndDayToDate;
//# sourceMappingURL=weekNumberAndDayToDate.js.map